import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type Store from '@ember-data/store';
import type InfinityService from 'ember-infinity/services/infinity';
import ExtendedInfinityModel from 'garaje/infinity-models/v3-offset';
import type { PaginatedRecordArray } from 'garaje/infinity-models/v3-offset';
import type PluginModel from 'garaje/models/plugin';
import type PluginInstallModel from 'garaje/models/plugin-install';
import type VfdConfigurationModel from 'garaje/models/vfd-configuration';
import type { RecordArray } from 'garaje/utils/type-utils';
import { hash } from 'rsvp';

import type { LocationOverviewVirtualFrontDeskModel } from '../route';

export type LocationOverviewVirtualFrontDeskLocationsModel = {
  configurations: PaginatedRecordArray<VfdConfigurationModel>;
  pluginInstalls: RecordArray<PluginInstallModel>;
  plugins: PluginModel[];
};

const PAGE_SIZE = 50; // number of locations to request at a time using paginated API

export default class LocationOverviewVirtualFrontDeskLocationsRoute extends Route {
  @service declare infinity: InfinityService;
  @service declare store: Store;

  async model(): Promise<LocationOverviewVirtualFrontDeskLocationsModel> {
    const { plugins } = <LocationOverviewVirtualFrontDeskModel>this.modelFor('location-overview.virtual-front-desk');

    const configurations = this.infinity.model(
      'vfd-configuration',
      {
        countParam: 'meta.total',
        include: 'contact-methods,contact-methods.user',
        pageParam: 'page[offset]',
        perPage: PAGE_SIZE,
        perPageParam: 'page[limit]',
        sort: '-enabled,location.name',
        startingPage: 0,
      },
      ExtendedInfinityModel
    );

    const pluginInstalls = this.store.query('plugin-install', {
      filter: {
        status: 'active',
      },
    });

    return hash({
      configurations,
      pluginInstalls,
      plugins,
    });
  }
}
